import { clipsQuery } from "../queries";
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApiConfig } from "@visioni/a3s-client-api/app";
import type { ClientApiFeatureSubPathParams } from "@visioni/a3s-client-api";
import type { ClipItem, ListClipsQueryParams } from "../../client-messages/clips";

export type UseClipsOptions = ClientApiFeatureSubPathParams &
  ListClipsQueryParams & {
    refetchInterval?: number;
    enabled?: boolean;
  };

export function useClips(options: UseClipsOptions): UseQueryResult<ClipItem[]> {
  const apiConfig = useApiConfig();
  const { enabled = true, refetchInterval = 0, startTime, endTime, limit, cursor, ...pathParams } = options;

  const queryParams = { startTime, endTime, limit, cursor };

  return useQuery({
    ...clipsQuery(apiConfig, pathParams, queryParams),
    enabled,
    select: (response) => response.data,
    refetchInterval,
    refetchOnMount: "always",
    refetchOnWindowFocus: true,
    refetchOnReconnect: true,
  });
}
